import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import * as React from 'react';
import styled from 'styled-components';
import { DSIconButton } from '../../Generic/Buttons/DSIconButton';
import { DSTypography } from '../../mui/Typography';
import { useCalendar } from '../Calendar.context';
import { useMonthFormat } from './use-month-format';

const FocusableIconButton = styled(DSIconButton)`
    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.palette.primary.main};
    }
`;

const CalendarHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
`;

export function CalendarMonthHeader(): JSX.Element {
    const { decrementMonth, displayMonth, displayYear, incrementMonth } = useCalendar();
    const { monthLabel } = useMonthFormat(displayYear, displayMonth);
    return (
        <CalendarHeaderContainer>
            {decrementMonth && (
                <FocusableIconButton onClick={() => decrementMonth()}>
                    <ChevronLeft />
                </FocusableIconButton>
            )}
            <DSTypography align="center" style={{ flexGrow: 1 }}>
                {monthLabel}
            </DSTypography>
            {incrementMonth && (
                <FocusableIconButton onClick={() => incrementMonth()}>
                    <ChevronRight />
                </FocusableIconButton>
            )}
        </CalendarHeaderContainer>
    );
}
CalendarMonthHeader.displayName = 'CalendarMonthHeader';
